import { afterRegistrationOpenDate } from 'Cohorts';
import { getProgramConfigValue } from 'Program';
import { subscriptionPastDue } from 'Subscription';
import { TuitionAndRegistrationSection, getTuitionAndRegistrationSection } from 'TuitionAndRegistrationSection';
import { type BaseUser } from './types';
import { getCohort, getTuitionContract } from './BaseUser';

export function getNeedsToRegister(user: BaseUser | null): boolean {
    if (!user) return false;
    const section = getTuitionAndRegistrationSection(user);
    return (
        !!section &&
        [
            TuitionAndRegistrationSection.cohortRegistrationPlanSelection,
            TuitionAndRegistrationSection.cohortRegistrationNoPlanSelection,
            TuitionAndRegistrationSection.cohortRegistrationFullScholarship,
        ].includes(section)
    );
}

export function getShouldVisitBillingPage(user: BaseUser | null): boolean {
    if (!user) return false;
    const cohort = getCohort(user);
    if (!cohort) return false;
    if (getProgramConfigValue(cohort.programType, 'supportsCohortPreApproval')) return false;
    if (!afterRegistrationOpenDate(cohort)) return false;

    const subscription = getTuitionContract(user)?.subscription;
    const section = getTuitionAndRegistrationSection(user);
    const needsToProvideBillingInfo =
        (section === TuitionAndRegistrationSection.registeredManageBilling && subscriptionPastDue(subscription)) ||
        section === TuitionAndRegistrationSection.specialCase;
    return getNeedsToRegister(user) || needsToProvideBillingInfo;
}
